module.exports = __webpack_public_path__ + "static/OGGETTODELBANDO-2e5b5396a309e0449a4e4a388d15b0e2.pdf";